module.exports = __webpack_public_path__ + "img/concept.4f5323e9.jpg";